<template>
        <div id='trainsure'>
            <NavTop title='报名信息' :islink='true' linkurl='/trainlist'/>
            <div class='content'>
               <div class="topcon">
                   <div class="topcon-part1">
                       <img class="topcon-part1-img" :src="traininfo.headimg"/>
                   </div>
                   <div class="topcon-part2">
                       <div class="topcon-part2-row topcon-part2-title">
                        {{traininfo.name}}
                       </div>
                       <div class="topcon-part2-row">
                        时间：{{traininfo.startdate}}-{{traininfo.enddate}}
                       </div>
                       <div class="topcon-part2-row">
                        地址：{{traininfo.address}}
                       </div>
                   </div>
               </div>
               <div class="centercon">
                   <div class="centercon-row">
                     <span class="centercon-label">姓名:</span>
                     <input class='centercon-input' placeholder="请输入学员姓名" v-model='traininfo.studentname'/>
                   </div>
                   <div class="centercon-row">
                    <span class="centercon-label">手机号:</span>
                    <input class='centercon-input' placeholder="请输入学员手机号码" v-model="traininfo.mobile"/>
                   </div>
                   <div class="centercon-row">
                    <span class="centercon-label">报名费用:</span>
                    <input class='centercon-input fontred' disabled :value="'¥'+traininfo.fee"/>
                   </div>
                   <div v-if='traininfo.isaddress==1'>
                        <div class="centercon-row">
                            <span class='centercon-input-left' @click='goAddress'>选择收货地址:</span>
                        </div>
                        <div class="centercon-row-wrap" v-if='tagAddress!=""' @click='goAddress'>
                            <span class='centercon-input-wrap'>{{tagAddress}}</span>
                        </div>
                   </div>
               </div>
              
               <div class="bottomcon">
                   <div class="bmbtn gobm" @click="saveTrainOrder">
                       <span>提交报名</span> 
                   </div> 
               </div>
            </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
         traininfo:{},
         processing:false,
         tagAddress:''
      }
  },  
  name: 'trainsure',
  computed:{
      isSetAddr(){
          return Object.keys(this.$store.state.address.choosedaddress).length===0 ? false :true
      },
      choosedAddr(){
          return this.$store.state.address.choosedaddress
      },
      trainid(){
          return this.$store.state.train.trainid
      }
  },
  created(){
     if(this.$route.params.trainid!=undefined){
         this.$store.commit("SET_TRAINID",{trainid:this.$route.params.trainid})
     }
     this.getTrainInfo()
  },
  methods:{
     getTrainInfo(){
        if(this.isSetAddr) this.tagAddress=this.choosedAddr.address+this.choosedAddr.name+this.choosedAddr.mobile

        if(this.trainid==undefined||this.trainid==''){
             this.$toast("页面参数有误，请稍后再试")
             return false
        } 

        this.$post("/school/getTrainInfo",{trainid:this.trainid}).then((data)=>{
               if(data.result.success){
                  this.traininfo=data.result.info
               }else{
                 this.$toast(data.result.info)
               }
           })   
     },
     goAddress(){
         this.$go("/addresslist/trainsure")
     },
     saveTrainOrder(){
        if(this.processing){
            this.$toast("请等待处理完成")
            return false
        } 
        if(this.trainid==undefined||this.trainid==''){
             this.$toast("页面参数有误，请稍后再试")
             return false
        } 
        if(this.traininfo.studentname==''||this.traininfo.studentname==undefined){
            this.$toast("学员姓名不能为空")
            return false
        }
        if(this.traininfo.mobile==""||this.traininfo.mobile==undefined){
            this.$toast("学员手机号码不能为空")
            return false
        }

        if(this.traininfo.isaddress==1 && !this.isSetAddr){
            this.$toast("请添加收货地址")
            return false
        }else if(this.traininfo.isaddress==1 && this.isSetAddr){
            this.traininfo.addressid=this.choosedAddr.id
        }

        this.processing=true
        this.$post("/school/saveTrainOrder",{trainid:this.trainid,traininfo:this.traininfo}).then((data)=>{
               this.processing=false
               if(data.result.success==1){
                   this.$toast(data.result.info)
                   setTimeout(()=>{this.$go("/traindetail/"+this.trainid)},1000)
               }else if(data.result.success==2){
                   this.$go("/paymentpx/"+data.result.info) 
               }else{
                  this.$toast(data.result.info)
               }
           }) 
     }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#trainsure{background-color:#F6F6F6;min-height: 100vh;width:100%;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;padding: 0.35rem;padding-top: 0!important;}
.topcon{display: flex;background-color:#fff;border-radius: 0.25rem;flex-flow: column nowrap;justify-content: center;align-items: center;border:1px solid #e7e7e7}
.topcon-part1{width:100%;}
.topcon-part1-img{width:100%;border-top-left-radius: 0.25rem;border-top-right-radius: 0.25rem;height:8rem;}
.topcon-part2{padding: 0.35rem;width:100%;}
.topcon-part2-row{color:#666666;font-size:0.4rem;}
.topcon-part2-title{font-size:0.45rem;color:#000;}
.centercon{width:100%;}
.centercon-row{margin-top:0.35rem;border-radius: 0.15rem;background-color: #fff;display: flex;flex-flow: row nowrap;align-items: center;height:1.35rem;padding: 0.2rem;border:1px solid #e7e7e7;text-align: left;}
.centercon-label{width:3rem;font-size:0.4rem;padding-left: 0.1rem;text-align: left;}
.centercon-input{flex:1;line-height: 1rem;text-align: right;font-size:0.4rem;background-color: #fff;border: none;}
.centercon-input-left{flex:1;line-height: 1rem;text-align: left;font-size:0.4rem;background-color: #fff;border: none;}
.centercon-row-wrap{border-radius: 0.15rem;background-color: #fff;display: flex;flex-flow: row wrap;align-items: center;padding: 0.2rem;border:1px solid #e7e7e7;text-align: left;}
.centercon-input-wrap{flex:1;line-height: 0.8rem;text-align: right;font-size:0.4rem;background-color: #fff;border: none;height:auto;text-align: left;}

.bottomcon{margin-top:0.35rem;width:100%;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;height:2rem;}
.bmbtn{width:100%;background-color: #999999;color:#fff;font-size:0.4rem;border-radius: 0.2rem;text-align: center;padding: 0.2rem;height:1.15rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}
.gobm{background-color: #ee0a24;}
.fontred{color:#ff3600!important}
</style>


